module.exports = __webpack_public_path__ + "static/img/bg-overview@w.eab1cc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/glovis-aa/bg-overview@w.jpg
// module id = ZDTN
// module chunks = 0